import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { NewChatModal } from '../../../modals/new-chat-modal/new-chat-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatService } from '../../../services';
import { AppFilter } from 'src/modules/shared/models';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';

interface IHeaders {
  field?: string;
  label?: string;
  type?: string;
  choices?: any[];
  op?: string;
  data?: any;
}
@Component({
  selector: 'app-all-conversations',
  templateUrl: './all-conversations.component.html',
  styleUrls: ['./all-conversations.component.scss'],
})
export class AllConversationsComponent implements OnInit {
  selectedConversation;
  newConversation;
  // @Input() conversations: any[];
  conversations: any[];
  filter: AppFilter = new AppFilter();
  totalItems: any = 0;
  success;
  error;
  pending;
  organizationId: any;

  messageParams: AppFilter;
  searchMessagesFilter = {
    groupOp: 'OR',
    rules: [],
  };

  searchFilter = {
    groupOp: 'OR',
    rules: [],
  };

  headers: IHeaders[] = [
    {
      field: 'service.serviceTypeId',
      label: 'Service Type Id',
      type: 'text',
      op: 'cn',
      data: '',
    },
  ];

  allTopics;
  allSubTopics;
  headerFilters: any[];
  currentPage: number = 1;
  sessionId;
  private eventSubscription: Subscription;
  fullScreenMode: boolean = false;
  private unsubscribe$: Subject<void> = new Subject<void>();
  constructor(
    private modalService: SuiModalService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private chatService: ChatService
  ) {
    this.filter = new AppFilter({
      _search: false,
      sidx: 'dateCreated',
      rows: 10,
      sord: 'desc',
    });
    this.organizationId = window.localStorage.getItem('organizationId');
    this.getOrganizationMessages(1);
    this.getData();
    this.getSessionAgreegatePage();
    const url = window.location.href; // Get the current URL
    const segments = url.split('/');
    this.selectedConversation = segments[segments.length - 1];
    this.eventSubscription = this.chatService.getEvent().subscribe((event) => {
      if (event) {
        this.refreshMessages(1);
      }
    });
    setInterval(() => {
      this.refreshMessages(1);
    }, 45000);
    this.eventSubscription = this.chatService
      .getFullScreenEvent()
      .subscribe((event) => {
        this.fullScreenMode = event;
      });
  }
  aggregateCount;
  getSessionAgreegatePage() {
    this.pending = true;
    this.filter.rows = 1000;
    this.chatService
      .getAggregateChatSessions()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res: any) => {
          this.aggregateCount = res.unread;
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.message
            ? error.error.message
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      // this.selectedConversation = params;
    });
  }

  getData(): void {
    this.pending = true;
    this.chatService.getAllChatTopics({}).subscribe(
      (res) => {
        this.allTopics = res;
        this.getSub();
      },
      (error) => {
        console.log(error);
        this.pending = false;
      }
    );
  }

  getSub(): void {
    this.pending = true;
    this.chatService.getAllChatSubTopics({}).subscribe(
      (res) => {
        this.allSubTopics = res;
        this.pending = false;
        this.headerFilters = this.allTopics.map((topic) => {
          return {
            field: `subtopic.subtopicId`, // Assuming the field format is 'topic.topicId'
            label: topic.topic, // Use the topic name as the label
            type: 'select',
            op: 'eq',
            choices: [], // This will be populated later based on subtopics
            data: '',
          };
        });
        this.headerFilters.forEach((headerFilter) => {
          const filteredSubtopics = this.allSubTopics.filter(
            (subtopic) => subtopic.topic.topic === headerFilter.label
          );
          headerFilter.choices = filteredSubtopics.map((subtopic) => ({
            optionId: subtopic.subtopicId,
            optionName: subtopic.subtopic,
          }));
        });
        console.log(this.headerFilters, 'filters');
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error;
      }
    );
  }
  refreshMessages(page) {
    this.filter.page = page;
    this.chatService
      .getAllOrganizationChatSessions({
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.conversations = res['rows'];
          this.conversations.sort((a, b) => {
            const dateA: Date = new Date(a.lastActivity);
            const dateB: Date = new Date(b.lastActivity);
            return dateB.getTime() - dateA.getTime();
          });
        },
        (error) => {
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getOrganizationMessages(page) {
    this.filter.page = page;
    this.pending = true;
    this.chatService
      .getAllOrganizationChatSessions({
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.pending = false;

          this.conversations = res['rows'];
          this.conversations.sort((a, b) => {
            const dateA: Date = new Date(a.lastActivity);
            const dateB: Date = new Date(b.lastActivity);
            return dateB.getTime() - dateA.getTime();
          });
          this.totalItems = res['records'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  searchRecords(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'subtopic.topic.topic',
          op: 'cn',
          data: '',
        },
        {
          field: 'subtopic.subtopic',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    searchFilter.rules[1].data = search;
    this.filter._search = true;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getOrganizationMessages(1);
  }
  advancedSearch(search) {
    console.log(search, 'search');
    if (search) {
      // this.filter = search;
      this.filter._search = true;
      this.filter.filters = JSON.stringify(search);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.currentPage = 1;
    this.filter.page = this.currentPage;
    this.filter.sidx = 'dateCreated';
    this.getOrganizationMessages(this.currentPage);
    console.log(this.filter);
  }
  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: 100,
      _search: false,
    });
    this.getOrganizationMessages(this.filter);
  }
  loadConversationView(session) {
    this.router.navigate([
      '/contractor/chat-window/conversation-screen',
      session.sessionId,
    ]);
    this.chatService.refreshConversationEvent.next(true);
    this.selectedConversation = session.sessionId;
  }
  initiateChat() {
    this.modalService
      .open(new NewChatModal({}))
      .onApprove((value: any) => {
        this.getOrganizationMessages(this.currentPage);
      })
      .onDeny(() => {
        // do nothing
      });
  }
}
